/**
 * Represent a User
 */
import {Permissions} from './permissions';

export class User {

  /**
   * the id of the customer (the moral person that employ the user)
   */
  public idCustomer: string;

  /**
   * the id of the user
   */
  public idUser: string;
  public groupId: string;


  /** the password (it can be empty) of the user
   *
   */
  public password: string;
  public firstName: string;
  public lastName: string;
  public lastConnection: Date;
  public businessCategory: string;
  public physicalDeliveryOfficeName: string;
  public supervisor: boolean;
  public admin: boolean;
  public requirePasswordChange: boolean;
  public permissions: Permissions;
  public isAuthorizedExpress: boolean;
  public isAuthorizedSendMail: boolean;
  public isErlAuthorized: boolean;
  /**
   * Default constructor, doing nothing
   */
  constructor() {
    this.permissions = new Permissions([]);
  }

}
